import { checkForUnsavedWork } from "./common/unsavedWorkCheck";
import { closeContentTab as closeContentTabReducer, addContentTab as addContentTabReducer, reloadContentTab as reloadContentTabReducer, setCurrentContentUrl as setCurrentContentUrlReducer, contentLoad as contentLoadReducer, openContentUrl as openContentUrlReducer, setActiveTab, tabInitialized, setDockedTab, } from "../features/slices/rootSlice";
import { v4 as createUuid } from "uuid";
import { getMenuIdFromUrl, getVisIdFromUrl } from "meta/utils/url";
import { patientDetailMenuId, patientDetailTitle, patientDetailUrl, } from "../utils/constants";
import { checkMaxNumberOfTabs } from "../utils/numberOfTabs";
import { endFrameSession } from "../utils/frameSession";
import { getRootAppWindow } from "meta/utils/getRootAppWindow";
import api from "../api";
export const setCurrentContentUrl = (url) => (dispatch, getState) => {
    let title = "";
    let menuId = getMenuIdFromUrl(url);
    if (menuId) {
        title = (getState().root.appSettings.StaticData.MenuItems[menuId] || {})
            .Title;
    }
    dispatch(setCurrentContentUrlReducer({ url, title }));
};
export const reloadContentTab = (disableCache) => (dispatch, getState) => {
    const state = getState();
    checkForUnsavedWork(state, state.root.activeTabKey).then(() => {
        dispatch(reloadContentTabReducer({ disableCache }));
    });
};
export const closeContentTab = (key) => (dispatch, getState) => {
    let state = getState();
    const tabToClose = key || state.root.activeTabKey;
    const rootFrame = getRootAppWindow(window);
    if (rootFrame.frames[tabToClose]) {
        rootFrame.frames[tabToClose].RootCommunicator.saveChildrenToPersist();
    }
    checkForUnsavedWork(state, tabToClose)
        .then(() => {
        // End frameSession for the tab
        endFrameSession(state.root.tabs[tabToClose].frameSession);
        dispatch(closeContentTabReducer(tabToClose));
    })
        .catch(() => { });
};
export const switchPatient = (visId, initialTab, isScanned = false) => (dispatch, getState) => {
    const state = getState();
    const keyToClose = state.root.activeTabKey;
    if (state.root.tabs[keyToClose].VisID == visId) {
        return;
    }
    const rootFrame = getRootAppWindow(window);
    checkForUnsavedWork(state, keyToClose).then(() => {
        if (rootFrame.frames[keyToClose]) {
            rootFrame.frames[keyToClose].RootCommunicator.saveChildrenToPersist();
        }
        dispatch(openPatientDetail(visId, initialTab, true, true, isScanned));
        endFrameSession(state.root.tabs[keyToClose].frameSession);
        dispatch(closeContentTabReducer(keyToClose));
    });
};
export const openPatientDetailWithUrl = (initialUrl, initialTitle) => (dispatch, getState) => {
    const visId = parseInt(getVisIdFromUrl(initialUrl) || "0", 10);
    const { tabs, appSettings } = getState().root;
    const menuId = getMenuIdFromUrl(initialUrl);
    const menuItem = menuId ? appSettings.StaticData.MenuItems[menuId] : {};
    const existingPatientDetailWithVisId = Object.keys(tabs).find((key) => tabs[key].VisID === visId &&
        tabs[key].menuId &&
        tabs[key].menuId?.toLocaleLowerCase() ===
            patientDetailMenuId.toLocaleLowerCase());
    if (existingPatientDetailWithVisId) {
        dispatch(setActiveTab(existingPatientDetailWithVisId));
        const rootFrame = getRootAppWindow(window);
        if (rootFrame) {
            rootFrame.frames[existingPatientDetailWithVisId].RootCommunicator.addChartTab({
                title: initialTitle || menuItem.Title,
                url: initialUrl,
                uniqueId: menuId,
                isPatientSpecific: menuItem.IsPatientSpecific
            });
        }
    }
    else {
        if (checkMaxNumberOfTabs(getState(), menuItem)) {
            let patDetailUrl = `${patientDetailUrl}&initialUrl=${encodeURIComponent(initialUrl)}`;
            if (initialTitle)
                patDetailUrl = `${patDetailUrl}&initialTitle=${initialTitle}`;
            dispatch(addContentTabReducer({
                menuId: patientDetailMenuId,
                frameSession: createUuid(),
                title: patientDetailTitle,
                url: patDetailUrl,
                docked: false,
                forceDocked: false,
                locked: false
            }));
        }
    }
};
export const openPatientDetail = (visId, initialTab, loadFromStorage = false, skipMaximumTabsCheck = false, isScanned = false) => (dispatch, getState) => {
    const { tabs, activeTabKey, appSettings } = getState().root;
    const currentTabOrder = tabs[activeTabKey].order;
    const existingPatientDetailWithVisId = Object.keys(tabs).find((key) => tabs[key].VisID === visId &&
        tabs[key].menuId &&
        tabs[key].menuId?.toLocaleLowerCase() ===
            patientDetailMenuId.toLocaleLowerCase());
    if (!existingPatientDetailWithVisId) {
        if (skipMaximumTabsCheck || checkMaxNumberOfTabs(getState(), appSettings.StaticData.MenuItems[patientDetailMenuId])) {
            var patDetailUrl = `${patientDetailUrl}&visId=${visId}&initialTab=${initialTab}&loadFromStorage=${loadFromStorage}&scanned=${isScanned}`;
            dispatch(addContentTabReducer({
                menuId: patientDetailMenuId,
                frameSession: createUuid(),
                title: patientDetailTitle,
                url: patDetailUrl,
                docked: false,
                forceDocked: false,
                locked: false
            }));
        }
    }
    else {
        dispatch(setActiveTab(existingPatientDetailWithVisId));
        api.setBarcodeState(tabs[existingPatientDetailWithVisId].frameSession ?? "", isScanned);
        const topFrame = getRootAppWindow(window);
        if (topFrame)
            topFrame.frames[existingPatientDetailWithVisId].RootCommunicator.openChartTab(initialTab);
    }
};
export const contentLoad = (key, url) => (dispatch, getState) => {
    const state = getState();
    const tab = state.root.tabs[key];
    const menuId = getMenuIdFromUrl(url);
    dispatch(tabInitialized(key));
    if (tab && !menuId) {
        // TODO log to keep track of screens without a menu ID; implement after assigning menu IDs to the pages, that appear the most
    }
    else if (tab && tab.menuId !== menuId) {
        const title = (state.root.appSettings.StaticData.MenuItems[menuId] || {}).Title ||
            tab.title;
        dispatch(contentLoadReducer({ key, menuId, title: title || "", }));
    }
};
export const openContentUrl = (url, title, locked, docked, forceDocked, forceLoad, width, allowRewrite) => (dispatch, getState) => {
    let state = getState();
    const menuId = getMenuIdFromUrl(url);
    const menuItem = menuId ? state.root.appSettings.StaticData.MenuItems[menuId] : {};
    title = title || menuItem.Title;
    //If item to open is PatientSpecific open patient detail
    if (menuItem.IsPatientSpecific) {
        dispatch(openPatientDetailWithUrl(url, title));
        return;
    }
    const existingMenuIdTabKey = Object.keys(state.root.tabs).find((key) => state.root.tabs[key].menuId && state.root.tabs[key].menuId === menuId);
    let activeTabkey = state.root.activeTabKey;
    if (existingMenuIdTabKey && state.root.tabs[existingMenuIdTabKey].dockable) {
        dispatch(setDockedTab(existingMenuIdTabKey));
        return;
    }
    if (existingMenuIdTabKey) {
        //If Tab with menuId exists and it is not selected we should switch to that tab.
        const reload = ((existingMenuIdTabKey === activeTabkey) || forceLoad === true);
        if (existingMenuIdTabKey !== activeTabkey) {
            dispatch(setActiveTab(existingMenuIdTabKey));
            //If Tab with menuId exists and it is selected we should reload them.
        }
        if (reload) {
            let currentTab = state.root.tabs[existingMenuIdTabKey];
            checkForUnsavedWork(state, activeTabkey, menuId, allowRewrite)
                .then(() => dispatch(openContentUrlReducer({
                url,
                title: title || currentTab.title || "",
                menuId
            })))
                .catch(() => { });
        }
        //If tab with menuId does not exsits we should open new one.
    }
    else {
        if (checkMaxNumberOfTabs(getState(), menuItem)) {
            const dockable = (state.root.appSettings.StaticData?.DockableMenuItems || []).includes(menuId);
            dispatch(addContentTabReducer({
                url,
                title: title || menuItem.Title,
                locked: locked || false,
                docked: docked || dockable || false,
                frameSession: createUuid(),
                menuId,
                forceDocked: forceDocked || false,
                width: width
            }));
        }
    }
};
export const showActivePageGuidAction = () => (_dispatch, getState) => {
    const state = getState();
    const active = state.root.tabs[state.root.activeTabKey];
    console.log(`Active page: ${active.title} menuId: ${active.menuId}`);
};
export const addContentTab = (options) => (dispatch) => {
    dispatch(openContentUrl(options.url, options.title, options.locked, options.docked, options.forceDocked, options.forceLoad, options.width, options.allowRewrite));
};
